import {ReactElement} from "react";
import {FormattedMessage} from "react-intl";
import {WineBadge} from "features/editor/MenuDocumentModel";

export interface BadgeProps {
    type: WineBadge
}

export function Badge(props: BadgeProps): ReactElement {
    return (
        <span className={`leading-tight rounded px-2 font-barlow font-medium text-white
                          ${props.type === 'seasonal' ? 'bg-[#CCB475]' : ''}
                          ${props.type === 'bio' ? 'bg-[#1E7200]' : ''}
                          ${props.type === 'bestSeller' ? 'bg-secondary' : ''}
                          ${props.type === 'housewine' ? 'bg-[#925555]' : ''}
                          ${props.type === 'wineOfMonth' ? 'bg-[#3f32a0]' : ''}
                          `}
              style={{paddingTop: "0.2rem", paddingBottom: "0.2rem"}}
        >
            <FormattedMessage id={`badge.${props.type}`} />
        </span>
    )
}